// @ts-nocheck
import React, { useCallback, useEffect, useRef, useState } from 'react';
import Email from './Email';
import Verify from './Verify';
import Preferences from './Preferences';
import { toast, ToastContainer } from 'react-toastify';
import Copilot from './Copilot';
import CopilotTwo from './CopilotTwo';
import KnowledgeBaseTwo from './KnowledgeBaseTwo';
import DashboardHome from './DashboardHome';
import Loader from './Loader';
import * as validateLoginAction from '../Action/Verify_Email/Validate_Login_Action';
import * as action from '../Action/Verify_Email/Verify_Email_Action';
import * as requestHelpAction from '../Action/Request_Help/Request_Help_Action';
import { useAppDispatch, useAppSelector } from '../hooks';
import { useLocation, useNavigate, useSearchParams, Navigate } from 'react-router-dom';
import ReleaseNotes from './ReleaseNotes';
import LicenseAndSubscription from './LicenseAndSubscription';
import UpgradeRequests from './UpgradeRequests';
import FeatureRequests from './FeatureRequests';
import GetSupport from './GetSupport';
import DiscoverAddons from "./DiscoverAddons";
import { getCookie, getSessionUserEmail } from '../config/common';
import * as profileAction from '../Action/Profile/Profile_Action';
import * as userDetailsAction from '../Action/User_Details/User_Details_Action';
import {
    parseDashboardProfilePayload,
    extractProfileRecordFromApiResponse,
    isApiSuccessEnvelope,
    mergeDashboardProfileParts,
} from '../utils/dashboardProfile';
import { PageActionsProvider } from '../contexts/PageActionsContext';
import DashboardSideNav from './DashboardSideNav';
import DashboardTopNav from './DashboardTopNav';
import { logoutUser } from '../utils/logoutUser';
import EmbeddedResource from './EmbeddedResource';
import { getDashboardTitle } from '../utils/dashboardTitle';
import { extractRolesFromSessionPayload, extractAccountsFromSessionPayload } from '../utils/roles';
import { defaultLandingPath, isPathlessRequest } from '../utils/landing';
import { legacyRedirectPath } from '../utils/legacyRoutes';
import { isDeniedRoles } from '../utils/access';
import DeniedAccount from './DeniedAccount';
import {
  canUseBetaPreview,
  clearLegacyBetaPreview,
  isBetaPreviewOn,
} from '../utils/betaPreview';

function LegacyGetSupportRedirect({ searchParams }) {
    const tab = searchParams.get('tab');
    const id = searchParams.get('id');
    const email = searchParams.get('email');
    const q = new URLSearchParams();
    if (id) q.set('id', id);
    if (email) q.set('email', email);
    const suffix = q.toString() ? `?${q.toString()}` : '';
    const to = tab === 'changeRequest' ? `/change-requests${suffix}` : `/support-tickets${suffix}`;
    return <Navigate to={to} replace />;
}

const RETURN_URL_KEY = 'copilot_returnUrl';
const SIDENAV_COLLAPSED_KEY = 'copilotSidenavCollapsed';

const Main = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
	const dispatch = useAppDispatch();
    const currentRoute = location.pathname;
    const dashboardPageTitle = getDashboardTitle(currentRoute);
	const verifyEmailLoading = useAppSelector(state => state.VerifyEmailReducer);
    const profilePayload = useAppSelector((state) => state.ProfileReducer?.payload);
    const [loading, setLoading] = useState(false);
    const [isEmailSubmit, setIsEmailSubmit] = useState('email');
    const [email, setEmail] = useState('');
    const [preferenceLoad, setPreferenceLoad] = useState(false);
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const [isValidUser, setIsValidUser] = useState(false);
    const [currentTheme, setCurrentTheme] = useState('light');
    const [, setData] = useState({
        roles: [],
        seniorities: [],
        notification: [],
        businessSegments: [],
        selNotification: [],
        contact: {}
    });
    const hasFetched = useRef();
    const [showChat, setShowChat] = useState(false);
    const [roles, setRoles] = useState([]);
    // Accounts this caller may act as + the active one (ACOP-79). Sourced from the same
    // validate-login payload as roles, so it refreshes on every load.
    const [accountCtx, setAccountCtx] = useState({ accounts: [], selectedAccountId: '' });
    /**
     * Whether the role set is an ANSWER yet, as opposed to the initial empty array.
     *
     * `roles` starts [] and hasRole([]) is false, so "not loaded yet" and "not an employee" look
     * identical from the array alone. The "/" landing resolver has to tell them apart: it redirects
     * with `replace`, so resolving on [] would send every employee to /copilot with no second
     * chance once the real roles land a moment later.
     */
    const [rolesResolved, setRolesResolved] = useState(false);
    /* Beta Preview (ACOP-140) lives here rather than in the side nav because the nav renders the
       switch and CopilotTwo needs the state. It ALWAYS starts off and is never saved — plain React
       state, so a reload or a new tab is off again (David, 2026-10-13). It gates no page. */
    const [betaOn, setBetaOn] = useState(false);
    useEffect(() => { clearLegacyBetaPreview(); }, []);

    /**
     * Apply a session payload's roles + accounts and mark the role set resolved.
     *
     * Resolved is set even when the payload carries neither — an empty or role-less response is a
     * real answer ("not an employee"), and the resolver above is waiting for one. Roles/accounts
     * themselves are only overwritten when present, so a partial refresh cannot blank them.
     */
    const applySessionPayload = (payload) => {
        const r = extractRolesFromSessionPayload(payload);
        if (r) setRoles(r);
        const a = extractAccountsFromSessionPayload(payload);
        if (a) setAccountCtx(a);
        setRolesResolved(true);
    };
    const [requestHelpData, setRequestHelpData] = useState({
        name: '',
        company: '',
        email: '',
        phone: '',
        description: '',
        showNeedHelpModal: false
    });

    const [sidenavCollapsed, setSidenavCollapsed] = useState(() => {
        if (typeof window === 'undefined') return false;
        try {
            return window.localStorage.getItem(SIDENAV_COLLAPSED_KEY) === '1';
        } catch (_) {
            return false;
        }
    });

    const [dashboardProfile, setDashboardProfile] = useState(() => {
        try {
            const cached = localStorage.getItem('copilot_profile');
            if (cached) return JSON.parse(cached);
        } catch (_) { /* ignore */ }
        return { fullName: '', seniority: '', jobTitle: '', company: '' };
    });

    useEffect(() => {
        try {
            window.localStorage.setItem(SIDENAV_COLLAPSED_KEY, sidenavCollapsed ? '1' : '0');
        } catch (_) { /* ignore */ }
    }, [sidenavCollapsed]);

    const [isNarrowViewport, setIsNarrowViewport] = useState(
        () => typeof window !== 'undefined' && window.matchMedia('(max-width: 991.98px)').matches
    );

    useEffect(() => {
        const mq = window.matchMedia('(max-width: 991.98px)');
        const handler = (e: MediaQueryListEvent) => setIsNarrowViewport(e.matches);
        mq.addEventListener('change', handler);
        return () => mq.removeEventListener('change', handler);
    }, []);

    const [logoutBusy, setLogoutBusy] = useState(false);
    const onLogout = async () => {
        if (logoutBusy) return;
        setLogoutBusy(true);
        try {
            await logoutUser();
        } finally {
            setLogoutBusy(false);
        }
    };

    // Initialize theme from cookie and listen for changes
    useEffect(() => {
        const saved = getCookie('theme');
        const theme = saved === 'dark' ? 'dark' : 'light';
        document.documentElement.setAttribute('data-bs-theme', theme);
        setCurrentTheme(theme);

        const onThemeChange = (e) => setCurrentTheme(e.detail);
        window.addEventListener('themechange', onThemeChange);
        return () => window.removeEventListener('themechange', onThemeChange);
    }, []);

    // Redirect deep links (email notifications) to /get-support when tab & id are present
    useEffect(() => {
        let parsedUrl = new URL(window.location.href);
        if (parsedUrl.searchParams.get("callback")) {
            try {
                parsedUrl = new URL(decodeURIComponent(parsedUrl.searchParams.get("callback")));
            } catch (_) { /* invalid callback URL — fall through */ }
        }

        const tab = parsedUrl.searchParams.get('tab');
        const id = parsedUrl.searchParams.get('id');

        if ((tab === 'ticket' || tab === 'changeRequest') && id) {
            const dest = tab === 'changeRequest' ? '/change-requests' : '/support-tickets';
            if (currentRoute === dest) return;
            const params = new URLSearchParams();
            params.set('id', id);
            const email = parsedUrl.searchParams.get('email');
            if (email) params.set('email', email);
            navigate(`${dest}?${params.toString()}`, { replace: true });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentRoute, navigate]);

    /* The resolved switch state. Derived so the role check and the flag can never drift apart:
       isBetaPreviewOn fails closed on anyone who is not an employee, so a flag left on across a role
       refresh reveals nothing. */
    const betaPreviewOn = isBetaPreviewOn(roles, betaOn);
    const canToggleBetaPreview = canUseBetaPreview(roles);

    /* Switching changes what Copilot searches, nothing else — it no longer swaps pages, so it does
       not navigate. */
    const toggleBetaPreview = useCallback(() => {
        setBetaOn((on) => !on);
    }, []);

    useEffect(() => {
        if (currentRoute === '/home') {
            document.title = 'Home';
        } else if (currentRoute === '/copilot') {
            document.title = 'Copilot';
        } else if (currentRoute === '/copilot-2') {
            document.title = 'Copilot';
        } else if (currentRoute === '/knowledge-base-2') {
            document.title = 'Knowledge Base';
        } else if (currentRoute === '/release-notes') {
            document.title = 'Change Log';
        } else if (currentRoute === '/feature-requests') {
            document.title = 'Feature Requests';
        } else if (currentRoute === '/get-support' || currentRoute === '/support-tickets') {
            document.title = 'Support tickets';
        } else if (currentRoute === '/change-requests') {
            document.title = 'Change requests';
        } else if (currentRoute === '/discover-addons') {
            document.title = 'Add-On Services';
        } else if (currentRoute === '/profile') {
            document.title = 'My profile';
        } else if (currentRoute === '/early-adopters') {
            document.title = 'Early Adopters';
        } else if (currentRoute === '/upgrade-requests') {
            document.title = 'Upgrade Requests';
        } else if (currentRoute === '/my-subscription') {
            document.title = 'My Subscription';
        } else if (currentRoute.startsWith('/resources/')) {
            document.title = 'Resources';
        } else {
            document.title = 'Copilot';
        }
    }, [currentRoute]);

	useEffect(() => {

        if (preferenceLoad) {
            hasFetched.current = false;
        }

		if (hasFetched.current) {
            return;
        }
		hasFetched.current = true;

        setLoading(true);

        let param = {};
        let currentUrl = window.location.href;
        var url = new URL(currentUrl);
        if (url.searchParams.get("callback")) {
            var callback = url.searchParams.get("callback") || '';
            url = new URL(decodeURIComponent(callback));
        }
        let originUrls = window.location.ancestorOrigins;
        if (originUrls) {
            originUrls = originUrls.length > 0 ? originUrls[originUrls.length - 1] : '';
        }
        
        // SECURITY NOTE: URL email is used ONLY for display/pre-filling login forms
        // It is NOT used for authorization - the API enforces session-based auth
        // All API calls use getUserEmail() which returns only the session cookie value
        param["email"] = url.searchParams.get("email") || '';
        param['url'] = originUrls ? originUrls : ((window.location !== window.parent.location) ? document.referrer : document.location.href);

        validateLogin(param);
        // eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

    useEffect(() => {
        const onVisible = () => {
            if (document.visibilityState === "visible" && showChat) {
                dispatch(validateLoginAction.validateLogin({}))
                    .then(applySessionPayload)
                    .catch(() => {});
            }
        };
        document.addEventListener("visibilitychange", onVisible);
        return () => document.removeEventListener("visibilitychange", onVisible);
    }, [dispatch, showChat]);

    /**
     * Access-code login (`Verify.tsx`) sets `showChat` and `reqData` but never runs `validateLogin`,
     * so `roles` stays []. Support-gated sidenav items (subscription, add-ons, early adopters, admin label)
     * stay hidden until a full reload. Re-fetch session once the dashboard is active.
     */
    useEffect(() => {
        if (!showChat) return;
        let cancelled = false;
        dispatch(validateLoginAction.validateLogin({}))
            .then((response) => {
                if (cancelled) return;
                /* Applied even for an empty response: this is the access-code path's only chance to
                   resolve roles, and the "/" resolver blocks until something does. */
                applySessionPayload(response);
            })
            .catch(() => {
                if (!cancelled) setRolesResolved(true);
            });
        return () => {
            cancelled = true;
        };
    }, [dispatch, showChat]);

    /**
     * SECURITY: Wipe any client-side artifacts of a prior session before
     * presenting the login form. Cookies may have been cleared (logout, expiry)
     * while `copilotUserEmail` / `reqData` linger in storage and surface the old
     * user's email in the dashboard chrome.
     */
    const clearStaleSessionArtifacts = () => {
        try { sessionStorage.removeItem('copilotUserEmail'); } catch (_) { /* ignore */ }
        try { localStorage.removeItem('reqData'); } catch (_) { /* ignore */ }
        setRoles([]);
        setRolesResolved(false);
        setAccountCtx({ accounts: [], selectedAccountId: '' });
        setDashboardProfile({ fullName: '', seniority: '', jobTitle: '' });
    };

    const enterLoginGate = (paramEmail) => {
        clearStaleSessionArtifacts();
        const fullUrl = window.location.pathname + window.location.search;
        if (fullUrl && fullUrl !== '/' && fullUrl !== '/login') {
            sessionStorage.setItem(RETURN_URL_KEY, fullUrl);
        }
        setLoading(false);
        setEmail(paramEmail);
        setIsEmailSubmit('email');
    };

    const validateLogin = async (param) => {
        dispatch(validateLoginAction.validateLogin({})).then((response) => {
            if (!response) {
                enterLoginGate(param.email);
                return;
            }
            if (response.status === 401) {
                enterLoginGate(param.email);
                return;
            }
            applySessionPayload(response);
            // Deep links from notifications omit `email`; cache session email from validate-login.
            if (response?.data?.email) {
                sessionStorage.setItem('copilotUserEmail', response.data.email);
            }
            verify(param);
		}).catch(error => {
            if (error?.__sessionExpired) {
                enterLoginGate(param.email);
                return;
            }
            console.log(error);
            if (error.response && (error.response.status === 404 || error.response.status === 400)) {
                enterLoginGate(param.email);
                return;
            }
			toast.error(error.message);
		})
    }

	const verify = async (param) => {
        dispatch(action.verifyEmail({ data: JSON.stringify(param) })).then((response) => {
            setLoading(false);
            if (response.status !== 1) {
                toast.error(response.message);
                // Fall back to the login gate rather than returning with showChat still false.
                // Every route block below is gated on showChat, and the gate only renders itself
                // on "/" and "/login" — so bailing out here on a deep link (e.g.
                // /upgrade-requests) left the user staring at a blank white page. enterLoginGate
                // also preserves the deep link, so they land back where they were after signing in.
                enterLoginGate(param.email);
                return;
            }
            setIsDataLoaded(true);
            if (response.message) {
                toast.success(response.message);
                enterLoginGate(param.email);
                return;
            }
            if (response.data && response.data.portalEng && !response.data.portalEng.seniority) {
                if (!param.email) {
                    setEmail('');
                    setIsEmailSubmit('email');
                    return;
                }
                response.data.contact.name = response.data.contact.name || '';
                response.data.contact.companyName = response.data.contact.companyName || '';
                response.data.contact.phone = response.data.contact.phone || '';
                response.data.selNotification = response.data.notificationPreferences;
                setData(response.data);
                setIsEmailSubmit('preferences');
                return;
            }
            setShowChat(true);
            setIsEmailSubmit('');
            if (param.email) sessionStorage.setItem('copilotUserEmail', param.email);
            localStorage.setItem('reqData', JSON.stringify(response.data));

            applySessionPayload(response.data);
            /* Session cookie is complete only after verify — refresh roles like a full page load. */
            dispatch(validateLoginAction.validateLogin({})).then((res) => {
                const r2 = extractRolesFromSessionPayload(res);
                if (r2) setRoles(r2);
            }).catch(() => {});

            // Restore deep link saved before re-authentication
            const returnUrl = sessionStorage.getItem(RETURN_URL_KEY);
            if (returnUrl) {
                sessionStorage.removeItem(RETURN_URL_KEY);
                navigate(returnUrl, { replace: true });
            } else if (window.location.pathname === '/login') {
                navigate('/', { replace: true });
            }
		}).catch(error => {
            console.log(error);
			toast.error(error.message);
            enterLoginGate(param.email);
		})
    }

    const hideNeedHelpModal = () => {
        setRequestHelpData({name: '', company: '', email: '', phone: '',  description: '', showNeedHelpModal: false});
    }

    const handleHelpInputChange = (e) => {
        setRequestHelpData({...requestHelpData, [e.target.name]: e.target.value});
    }

    const requestHelp = () => {
        var param = requestHelpData;
        if (!param.name || param.name.trim().length === 0 || !param.company || param.company.trim().length === 0
            || !param.email || param.email.trim().length === 0 || !param.phone || param.phone.trim().length === 0
            || !param.description || param.description.trim().length === 0) {
            toast.error("All Fields are Required.");
            return;
        }
        setLoading(true);
        dispatch(requestHelpAction.request_help({ data: JSON.stringify(param) })).then((response) => {
            setLoading(false);
            if (response.status !== 1) {
                toast.error(response.message);
                return;
            }
            hideNeedHelpModal();
            setTimeout(() => {
                toast.success("Support has been notified. Thank you!");
            }, 100);
        }).catch(error => {
            toast.error(error.message);
        })
    }

    const isAuthGate = !showChat && (currentRoute === '/' || currentRoute === '/login');
    const containerClass = isAuthGate ? 'main-container' : 'main-container  full-width';
    /**
     * Show the login shell full-bleed whenever the user is unauthenticated and on
     * the email/access-code step — including deep links into protected routes
     * (e.g. /get-support, /copilot). Without this, those routes would fall back
     * to the cramped main-container styling meant for in-dashboard panels.
     */
    const loginFullBleed = !showChat && (isEmailSubmit === 'email' || isEmailSubmit === 'verify');

    /**
     * SECURITY: Dashboard chrome (sidebar / top bar) only after authentication.
     * Popup/embed mode used to force chrome on while still on the login gate
     * (`isPopupMode || showChat`), which left sidenav visible and squeezed the
     * split login into the content column. Standalone staging never hit that path.
     * After sign-in, showChat is true and chrome returns for both popup and full page.
     */
    const showSidebar = showChat;

    useEffect(() => {
        if (!showSidebar) return;
        let baseline = { fullName: '', seniority: '', jobTitle: '' };
        try {
            const raw = localStorage.getItem('reqData');
            if (raw) {
                baseline = parseDashboardProfilePayload(JSON.parse(raw));
                setDashboardProfile(baseline);
            }
        } catch (_) {
            /* ignore */
        }
        const email = getSessionUserEmail();
        if (!email) return;
        const param = { data: JSON.stringify({ email }) };
        /* profile/getdata + user/details — merge with cached reqData so nothing is dropped. */
        Promise.allSettled([
            dispatch(profileAction.profile(param)),
            dispatch(userDetailsAction.user_details(param)),
        ]).then((results) => {
            let merged = { ...baseline };
            for (const r of results) {
                if (r.status !== 'fulfilled') continue;
                const response = r.value;
                if (!response || !isApiSuccessEnvelope(response)) continue;
                const rec =
                    extractProfileRecordFromApiResponse(response) ||
                    (response?.data && typeof response.data === 'object'
                        ? extractProfileRecordFromApiResponse(response.data) || response.data
                        : null);
                if (!rec || typeof rec !== 'object') continue;
                /* Prefer API fields over cached reqData (first arg wins when set). */
                merged = mergeDashboardProfileParts(
                    parseDashboardProfilePayload(rec),
                    merged,
                );
            }
            if (merged.fullName || merged.jobTitle || merged.seniority) {
                setDashboardProfile(merged);
                try { localStorage.setItem('copilot_profile', JSON.stringify(merged)); } catch (_) { /* ignore */ }
            }
        });
    }, [dispatch, showSidebar]);

    /** When Profile loads elsewhere or PROFILE_SUCCESS fires, mirror into the top bar. */
    useEffect(() => {
        if (!showSidebar) return;
        const rec = extractProfileRecordFromApiResponse(profilePayload);
        if (!rec) return;
        const next = parseDashboardProfilePayload(rec);
        if (next.fullName || next.jobTitle || next.seniority) {
            setDashboardProfile(next);
            try { localStorage.setItem('copilot_profile', JSON.stringify(next)); } catch (_) { /* ignore */ }
        }
    }, [showSidebar, profilePayload]);

    const embedUrlParam = searchParams.get('url');

    /**
     * Safety net against a blank page.
     *
     * Every route block below requires showChat, and the sign-in views require isEmailSubmit to be
     * one of 'email' | 'preferences' | 'verify'. If the app ever settles outside BOTH — a bail-out
     * in the bootstrap that forgets to route somewhere, say — it renders literally nothing, which
     * is what a deep link to /upgrade-requests used to do. Treat that state as "show the sign-in
     * gate": the known bail-outs are fixed above, and this keeps any future one from being a white
     * screen. Gated on isDataLoaded so it cannot flash during the initial load.
     */
    const strandedWithNothingToShow =
      !showChat && isDataLoaded && !['email', 'preferences', 'verify'].includes(isEmailSubmit);

    const mainContent = (
      <>
        {strandedWithNothingToShow && (
          <Email
            setIsEmailSubmit={setIsEmailSubmit}
            setData={setData}
            setLoading={setLoading}
            setEmail={setEmail}
            email={email}
            requestHelpData={requestHelpData}
            setRequestHelpData={setRequestHelpData}
          />
        )}
        {isEmailSubmit === "email" && !showChat && (
          <Email
            setIsEmailSubmit={setIsEmailSubmit}
            setData={setData}
            setLoading={setLoading}
            setEmail={setEmail}
            email={email}
            requestHelpData={requestHelpData}
            setRequestHelpData={setRequestHelpData}
          />
        )}
        {isEmailSubmit === "preferences" && !showChat && (
          <Preferences
            setIsEmailSubmit={setIsEmailSubmit}
            email={email}
            setPreferenceLoad={setPreferenceLoad}
            requestHelpData={requestHelpData}
            setRequestHelpData={setRequestHelpData}
          />
        )}
        {isEmailSubmit === "verify" && !showChat && (
          <Verify
            setIsEmailSubmit={setIsEmailSubmit}
            email={email}
            setEmail={setEmail}
            setPreferenceLoad={setPreferenceLoad}
            setShowChat={setShowChat}
            requestHelpData={requestHelpData}
            setRequestHelpData={setRequestHelpData}
          />
        )}
        {/* The ONLY path that resolves to a default: a request that named no page at all.
            EVERYONE goes to Home (ACOP-140) — no role and no switch decides it any more (ACOP-70
            landed employees on Home by role; that and the 2026-08-28 Beta Preview landing are both
            retired).

            Deep links are deliberately absent from this rule — /support-tickets?id=... renders
            support tickets, it is never bounced through a landing page that would drop the id.

            The query string is carried over because the Salesforce utility-bar embed loads
            "/?hideTitle=true&email=...", and LoginLayout and isOpenFromAvSight() read hideTitle from the URL.

            Held on rolesResolved rather than redirecting on roles=[]: the redirect replaces the
            history entry, so guessing early and guessing wrong is not recoverable. */}
        {isPathlessRequest(currentRoute) && showChat && (
          rolesResolved
            ? <Navigate to={`${defaultLandingPath()}${location.search || ""}`} replace />
            : <Loader panel />
        )}
        {/* Old routes redirect, they are not cleaned up (ACOP-140): somebody may have bookmarked
            /copilot or the iframe-backed /resources/knowledge-base. The query string and hash are
            carried over. The new -2 routes below render for everyone — Beta Preview gates none. */}
        {showChat && legacyRedirectPath(currentRoute) && (
          <Navigate to={`${legacyRedirectPath(currentRoute)}${location.search || ""}${location.hash || ""}`} replace />
        )}
        {currentRoute === "/home" && showChat && (
          <DashboardHome
            onOpenFullArticle={(urlname) => {
              // Keep the current query string (the Salesforce embed's hideTitle/email) and set
              // only the article, so the SPA route change lands on the same full-size view
              // Copilot's slide-out opens.
              const params = new URLSearchParams(location.search);
              params.set("article", urlname);
              navigate(`/knowledge-base-2?${params.toString()}`);
            }}
          />
        )}

        {/* The new Copilot and Knowledge Base are plain renders for every non-denied user. What a
            user may SEARCH is bounded server-side — the avs-os endpoints apply the tier floor
            (roleMiddleware.ts) and AVS OS scopes sources by the employee role (ACOP-139 / ACOP-142);
            Beta Preview only adds the employee-only extras to the request (CopilotTwo). */}
        {currentRoute === "/copilot-2" && showChat && (
          <CopilotTwo roles={roles} userFullName={dashboardProfile.fullName} betaPreviewOn={betaPreviewOn} />
        )}
        {currentRoute === "/knowledge-base-2" && showChat && <KnowledgeBaseTwo includeInternal={betaPreviewOn} />}

        {currentRoute === "/profile" && showChat && (
          <Copilot roles={roles} setRoles={setRoles} initialPanel="profile" />
        )}
        {currentRoute === "/early-adopters" && showChat && (
          <Copilot roles={roles} setRoles={setRoles} initialPanel="earlyAdopters" />
        )}
        {currentRoute === "/upgrade-requests" && showChat && <UpgradeRequests />}
        {currentRoute === "/my-subscription" && showChat && <LicenseAndSubscription />}
        {currentRoute === "/release-notes" && showChat && <ReleaseNotes roles={roles} />}
        {currentRoute === "/feature-requests" && showChat && (
          <FeatureRequests
            data={verifyEmailLoading.payload}
            isDataLoaded={isDataLoaded}
            isValidUser={isValidUser}
            setIsDataLoaded={setIsDataLoaded}
            setIsValidUser={setIsValidUser}
          />
        )}
        {currentRoute === "/get-support" && showChat && <LegacyGetSupportRedirect searchParams={searchParams} />}
        {currentRoute === "/support-tickets" && showChat && <GetSupport roles={roles} view="tickets" />}
        {currentRoute === "/change-requests" && showChat && <GetSupport roles={roles} view="changeRequests" />}
        {currentRoute === "/discover-addons" && showChat && <DiscoverAddons />}
        {currentRoute === "/resources/university" && showChat && (
          <EmbeddedResource title="AvSight University" src="https://avsight.northpass.com/app" />
        )}
        {currentRoute === "/resources/embed" && showChat && embedUrlParam && (
          <EmbeddedResource title="Linked content" src={embedUrlParam} />
        )}
      </>
    );

    /* A denied account that is somehow signed in gets a dead end — no nav, no routes, no data calls
       (ACOP-140). Sign-in already refuses these accounts; this is the backstop. Only once the roles
       have RESOLVED: isDeniedRoles is false for an empty or unresolved set, so a slow session
       refresh never flashes this at a good user. */
    if (showChat && rolesResolved && isDeniedRoles(roles)) {
      return <DeniedAccount onLogout={onLogout} logoutBusy={logoutBusy} />;
    }

    return (
      <>
        {loading && !showSidebar ? (
          <Loader />
        ) : (
          <>
            {showSidebar ? (
              <PageActionsProvider>
                <div className="copilot-dashboard d-flex flex-column vh-100 w-100 bg-body overflow-hidden">
                <div
                  className={`d-flex flex-grow-1 min-vh-0 copilot-dashboard-body${
                    sidenavCollapsed ? " copilot-dashboard-body--sidenav-collapsed" : ""
                  }`}
                >
                  <DashboardSideNav
                    roles={roles}
                    accountCtx={accountCtx}
                    collapsed={sidenavCollapsed || isNarrowViewport}
                    forcedCollapsed={isNarrowViewport}
                    onToggleCollapsed={() => setSidenavCollapsed((c) => !c)}
                    sessionActive={showChat}
                    betaPreviewOn={betaPreviewOn}
                    canToggleBetaPreview={canToggleBetaPreview}
                    onToggleBetaPreview={toggleBetaPreview}
                  />
                  <main className="copilot-dashboard-main flex-grow-1 min-w-0 d-flex flex-column overflow-hidden min-h-0">
                    <DashboardTopNav
                      profileFullName={dashboardProfile.fullName}
                      profileSeniority={dashboardProfile.seniority}
                      profileJobTitle={dashboardProfile.jobTitle}
                      profileCompany={dashboardProfile.company}
                      accountCtx={accountCtx}
                      roles={roles}
                      onLogout={onLogout}
                      logoutBusy={logoutBusy}
                    />
                    <div
                      className={`copilot-dashboard-content position-relative flex-grow-1 min-h-0 d-flex flex-column ${containerClass}${(currentRoute === '/copilot-2' || currentRoute === '/copilot' || currentRoute.startsWith('/resources/')) ? ' copilot-dashboard-content--copilot2' : ''}`}
                    >
                      {loading ? <Loader panel /> : mainContent}
                    </div>
                  </main>
                </div>
                </div>
              </PageActionsProvider>
            ) : (
              <div className={loginFullBleed ? 'w-100' : containerClass}>{mainContent}</div>
            )}
            <ToastContainer
              position="top-right"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme={currentTheme}
            />
          </>
        )}

        {/* create case */}
        {requestHelpData.showNeedHelpModal && (
          <>
            <div
              className="modal fade show"
              id="needHelpModal"
              role="dialog"
              aria-labelledby="needHelpModalLabel"
              aria-hidden="true"
              style={{ display: "block" }}
            >
              <div className="modal-dialog modal-lg mw-570" role="document">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="needHelpModalLabel">
                      Request Help
                    </h5>
                    <button
                      className="close"
                      type="button"
                      data-dismiss="modal"
                      aria-label="Close"
                      onClick={hideNeedHelpModal}
                    >
                      <span aria-hidden="true">×</span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <form>
                      <div className="row">
                        <div className="col-md-12">
                          <div className="form-group">
                            <label className="col-form-label">
                              Name<span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="name"
                              value={requestHelpData.name}
                              onChange={(e) => handleHelpInputChange(e)}
                            />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <label className="col-form-label">
                              Company<span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="company"
                              value={requestHelpData.company}
                              onChange={(e) => handleHelpInputChange(e)}
                            />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <label className="col-form-label">
                              Email<span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="email"
                              value={requestHelpData.email}
                              onChange={(e) => handleHelpInputChange(e)}
                            />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <label className="col-form-label">
                              Phone<span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="phone"
                              value={requestHelpData.phone}
                              onChange={(e) => handleHelpInputChange(e)}
                            />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <label className="col-form-label">
                              What do you need help with?
                              <span className="text-danger">*</span>
                            </label>
                            <textarea
                              className="form-control"
                              name="description"
                              value={requestHelpData.description}
                              onChange={(e) => handleHelpInputChange(e)}
                            ></textarea>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                  <div className="modal-footer">
                    <button
                      className="btn btn-secondary"
                      type="button"
                      data-dismiss="modal"
                      onClick={hideNeedHelpModal}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn btn-primary"
                      onClick={requestHelp}
                    >
                      Request Help
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-backdrop fade show"></div>
          </>
        )}
      </>
    );
}

export default Main;